import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from '../forms/useForm';
import { usePagination } from '../pagination/usePagination';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';

export const useCreateWorkSheetSanitary = () => {

    const [catWorkSheet, setcatWorkSheet] = useState([]);
    const [idwsconfig, setidwsconfig] = useState(0);
    const [dataDatacatWorkSheetSearch, setDatacatWorkSheetSearch] = useState([]);

  
    const [method, setMethod] = useState("");
    const [modal, setModal] = useState(false);
    const [modalTitle,setModalTitle] = useState("");

    const [loading, setLoading] = useState(false);
    const [createSweet] = useSweetAlert();
    const history = useHistory();
    const [datadeterminations, setdatadeterminations] = useState([]);
    const [datatypesamples, setdatatypesamples] = useState([]);
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);

    const [formValues, handleInputChange, , handleUpdateValues, handleSelectValues] = useForm({
        name_ws:"",
        id_type_sample:0,
        list_determinations:[]
        });
    const [validaciones, setValidaciones] = useState({
        name_ws_valid:false,
        id_type_sample_valid:false,
        list_determinations_valid:false,
    })
    const {name_ws,id_type_sample, list_determinations} = formValues;

    const numberItems = 10;
    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(catWorkSheet.length, numberItems);

    useEffect(() => {
        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;
        let listcatWorkSheet = [];
        catWorkSheet.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listcatWorkSheet.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setcatWorkSheet(listcatWorkSheet);
    }, [totalPageCount, currentPage])

    const openDialog = (title, mode) => {
        setModalTitle(title);
        setMethod(mode);
        setModal(true);
    };

    const closeDialog = () => {
        setModal(false);
    };

   
     const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setShowDeleteAlert(false); 
        setModalAlert(false);   
    };
    

   
    useEffect(()=>{
        getWSSanitary();
        getWSDeterminations();
        getTypeSample();
    },[history.location]);


    const getWSSanitary = async () => {
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "WorkSheetSanitary/ListWSConfig");

        if (respuesta.code === 200) {
            let listcatWorkSheet= [];
            let startItems = 0;
            let endItems = numberItems;
            let aux = numberItems * currentPage;

            endItems = aux;

            startItems = endItems - numberItems;

            if (respuesta.data.length >= 1) {
                respuesta.data.forEach( (data,index) => {
                    
                let posicion = index + 1;
                let visibleTable = false;
                
                if (posicion > startItems && posicion <= endItems) {
                    visibleTable = true;
                }

                listcatWorkSheet.push({
                        idwsconfig: data.idwsconfig,
                        id_type_sample: data.id_type_sample,
                        name_ws: data.name_ws,
                        name_type_sample: data.name_type_sample,
                        list_determinations: data.list_determinations,
                        list_determinations_text: data.list_determinations.map(t => t.name).join(", "),
                       
                    });
                });
                setcatWorkSheet(listcatWorkSheet);
                setDatacatWorkSheetSearch(listcatWorkSheet);
            }
        }
    }
    const getWSDeterminations = async () => {
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "WorkSheetSanitary/ListDeterminationsWSS");

        if (respuesta.code === 200) {
           
            let listDeterminations= [];
            if (respuesta.data.length >= 1) {
                respuesta.data.forEach( (data,index) => {
                    listDeterminations.push({
                        value: data.id_exam,
                        label: data.name,
                    });
                });
                setdatadeterminations(listDeterminations);
            }
           
        }
    }
    const getTypeSample = async () => {
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "TypeSamples/List");

        if (respuesta.code === 200) {
           
            let listTypeSample= [];
            if (respuesta.data.length >= 1) {
                respuesta.data.forEach( (data,index) => {
                    listTypeSample.push({
                        value: data.id_mic_type_sample,
                        label: data.name,
                    });
                });
                setdatatypesamples(listTypeSample);
            }
           
        }
    }

    
    const handleCreate = () => {
        handleUpdateValues({
            name_ws: "",
            id_type_sample:"",
            list_determinations:[]
        });

        setValidaciones({
            name_ws_valid:false,
            id_type_sample_valid:false,
            list_determinations_valid:false,
        });

        setidwsconfig(0);
        setMethod("create");
        setModalTitle("Crear una nueva hoja de trabajo");
        openDialog("Crear una nueva hoja de trabajo", "create");
    }   

    const saveCreate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }
        let mValues = JSON.stringify(formValues);
        console.log(mValues,"mValues");

        let requestOptions = {
            method: 'POST',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "WorkSheetSanitary/Create");
        if (respuesta.code === 200) {
            getWSSanitary();
            createSweet("create", "success", "Éxito!", "Creado con éxito");
            setLoading(false);
            closeDialog();
        }
    }

    const handleUpdate = (idwsconfig) => {
        let catWorkSheettemp = catWorkSheet.find(s => s.idwsconfig === idwsconfig);
        const formattedDeterminations = catWorkSheettemp.list_determinations.map(det => ({
            value: det.id_exam,       
            label: det.name      
        }));
        
        handleUpdateValues({
            name_ws: catWorkSheettemp.name_ws,
            id_type_sample: catWorkSheettemp.id_type_sample,
            list_determinations: formattedDeterminations,
        });
        
        

        setValidaciones({
            name_ws_valid:false,
            id_type_sample_valid:false,
            list_determinations_valid:false,
        });

        setidwsconfig(idwsconfig);
        setMethod("update");
        setModalTitle("Modificación de Hoja de Trabajo");
        openDialog("Modificación de la hoja de trabajo", "update");
    }


    const saveUpdate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let body = {
            idwsconfig: idwsconfig,
            ...{ ...formValues }
        };

        let mValues = JSON.stringify(body);
        
        let requestOptions = {
            method: 'PUT',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "WorkSheetSanitary/Update");

        if (respuesta.code === 200) {
            getWSSanitary();
            createSweet("create", "success", "Exito!", "Hoja de Trabajo Actualizada");
            setLoading(false);
            closeDialog();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveUpdate);
        }
    }

    const handleDelete = (idwsconfig) => {
        
        let catWorkSheettemp = catWorkSheet.find(s => s.idwsconfig === idwsconfig);

        handleUpdateValues({
            name_ws: catWorkSheettemp.name_ws,
            id_type_sample:catWorkSheettemp.id_type_sample,
            list_determinations:catWorkSheettemp.list_determinations,
        });

        setidwsconfig(idwsconfig);
        setMethod("delete");
        setModalTitle("eliminar");
        openDeleteAlert();
    }

    const saveDelete = async (e) => {
        e.preventDefault();

        setLoading(true);

        let requestOptions = {
            method: 'DELETE'
        };

        const respuesta = await sendRequest(requestOptions, `WorkSheetSanitary/${idwsconfig}`);

        if (respuesta.code === 200) {
            getWSSanitary();
            setLoading(false);
            createSweet("create", "success", "Exito!", "Hoja de Trabajo Deshabilitada");
            closeDeleteAlert();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveDelete);
        }
       

    }

    const validarForm = () => {
        let statusValidation = false;
        let newValidations = {};
       // console.log("formadatos");
      
        if (formValues.name_ws === "" || formValues.name_ws.length < 3) {
            newValidations = {
                ...newValidations,
                name_ws_valid: true
            };
            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                name_ws_valid: false
            }
        }
        if (formValues.id_type_sample <= 0) {
            newValidations = {
                ...newValidations,
                id_type_sample_valid: true
            };
            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                id_type_sample_valid: false
            }
        }
       
        if (!Array.isArray(formValues.list_determinations) || formValues.list_determinations.length < 0) {
            newValidations = {
                ...newValidations,
                list_determinations_valid: true
            };
            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                list_determinations_valid: false
            }
        }
        setValidaciones(newValidations);

        return statusValidation;
    }

    const handleSearchWSS = (e) => {

        let busqueda = e.target.value;
        let newMethod = [];

        dataDatacatWorkSheetSearch.forEach(element => {            

            let cadena = element.name_ws.toUpperCase();
            if (cadena.indexOf(busqueda.toUpperCase()) > -1) {
                element.visibleTable = true;
                newMethod.push(element);
            }
        });
        setcatWorkSheet(newMethod);
    }
    const navigateNewProcessWS = (idwsconfig) => {
        let find_ws = catWorkSheet.find(x => x.idwsconfig === idwsconfig);
            history.push("../sanitaria/creacion_procesos/" + idwsconfig);

        
    }


    const handleExcelWorkSheet = async () => {
        setLoadingExport(true);

        try {
            const XLSX = await import("xlsx");

            const _report = catWorkSheet.map((item, index) => ({
                "#": index + 1,
                "Nombre": item.name_ws || "----",
                "Tipo de muestra": item.name_type_sample || "---",            
                "Determinaciones": item.list_determinations?.length
                    ? item.list_determinations.map(det => det.name).join(", ")
                    : "---"  
                }));

            const worksheet = XLSX.utils.json_to_sheet(_report);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Listado_hojas_trabajo");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const dataBlob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "catálogo_hojas_trabajo.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar Excel", error);
        }

        setLoadingExport(false);
    };

    const [searchWorkSheetSanitary, setSearchWorkSheetSanitary] = useState("");
    const handleSearch = (e) => {
        setSearchWorkSheetSanitary(e);

        let busqueda = e.toUpperCase();
        let newWorkSheet = [];

        if (busqueda === "") {
            setcatWorkSheet([...dataDatacatWorkSheetSearch]); 
        } else {
            dataDatacatWorkSheetSearch.forEach(element => {

                let cadena = element.name_ws.toUpperCase();
                let cadenaTypeSample = element.name_type_sample.toUpperCase();
                let cadenaDeterminations = element.list_determinations?.some(det =>
                    det.name.toUpperCase().includes(busqueda)
                );

                if (
                    cadena.includes(busqueda) || 
                    cadenaTypeSample.includes(busqueda) || 
                    cadenaDeterminations
                ) {
                    newWorkSheet.push(element);
                }
            });

            setcatWorkSheet(newWorkSheet);
        }
    };

    const handleClear = () => {
        setSearchWorkSheetSanitary("");                         
        localStorage.removeItem("globalFilter");    
        setcatWorkSheet([...dataDatacatWorkSheetSearch]);
    };

    return {
        catWorkSheet,name_ws,id_type_sample,list_determinations,validaciones,
        method, 
        handleInputChange, handleSearchWSS, loading, 
        closeDialog, modal, modalTitle,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        nextPage, previousPage, goToPage, totalPageCount, currentPage,
        datadeterminations,handleUpdateValues,datatypesamples,handleSelectValues,formValues,
        navigateNewProcessWS,
        showDeleteAlert, modalAlert, closeDeleteAlert,
        handleClear, handleSearch, searchWorkSheetSanitary, handleExcelWorkSheet, loadingExport
    }

}




